module.exports = __webpack_public_path__ + "media/assets/images/payments/master_card-bddd90932c3fc6cd30bbba59916b0259.png";